import { Box, Button, Dialog, DialogActions, Grid, IconButton, List, Menu, MenuItem, Typography } from "@mui/material";
import { CardProps } from ".";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import { TLoja } from "../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa";
import { TPagamentoDetalhes, TProdutosDetalhes } from "../../../../../types/api/comercial/detalhar-pedido";
import { Fragment, useContext, useMemo, useState } from "react";
import { ShoppingCart } from "@mui/icons-material";
import ListaProdutos from "../../MIPedidos/DialogCriarPedidoVenda/CriarPedido/ListaProdutos";
import { ICarrinhoItem } from "../../MIPedidos/DialogCriarPedidoVenda/CriarPedido";
import DialogEditItem from "../../MIPedidos/DialogCriarPedidoVenda/CriarPedido/CarrinhoCard/DialogEditItem";
import { useFormContext } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { IDataPublicos } from "../../../../../types/api/geral/pesquisar-publicos";
import { IPerfisVinculados } from "../../../../../types/api/geral/usuario";
import { IEditarPedidoPayload } from "../../../../../types/mutations/comercial/editar-pedido";
import DialogReceituario from "../../MIPedidos/DialogCriarPedidoVenda/CriarPedido/Checkout/ListaItens/DialogReceituario";
import { IReceituarioData, IReceituarioItem } from "../../MIPedidos/DialogCriarPedidoVenda/CriarPedido/Checkout/ListaItens";

export default function CardItens({
    data
}: PropsCardItens) {
    const queryClient = useQueryClient();
    const [openDialogEdit, setOpenDialogEdit] = useState<boolean>(false);
    const [openDialogEditItem, setOpenDialogEditItem] = useState<TProdutosDetalhes | null>(null);
    const { watch } = useFormContext();
    const formData = watch()
    const itens: ICarrinhoItem[] = watch('itens')
    const [menuState, setMenuState] = useState<{
        anchorEl: HTMLElement | null;
        itemId: string | null;
        lojaId: number | null;
    }>({
        anchorEl: null,
        itemId: null,
        lojaId: null
    });
    const [openDialogReceita, setOpenDialogReceita] = useState<ICarrinhoItem[] | null>(null);

    const { getUserData } = useContext(AuthContext);

    const vendedores = useMemo(() => {
        const perfisVendedores = getUserData()?.perfis_vinculados
            .filter((perfil: IPerfisVinculados) =>
                perfil.vendedor &&
                perfil.vendedor.id === data.vendedor.id
            ) || []
        return perfisVendedores.map((perfil: IPerfisVinculados) => perfil.vendedor).length > 0;
    }, [getUserData, data])

    const handleClick = (event: React.MouseEvent<HTMLElement>, itemId: string, lojaId: number) => {
        setMenuState({
            anchorEl: event.currentTarget,
            itemId: itemId,
            lojaId: lojaId
        });
    };

    const handleClose = () => {
        setMenuState({
            anchorEl: null,
            itemId: null,
            lojaId: null
        });
    };

    const onEditarItem = (item: TProdutosDetalhes) => {
        setOpenDialogEditItem(item);
        handleClose();
    };

    const handleSaveReceituario = (data: IReceituarioData) => {
        if (data && data.itens && openDialogReceita) {
            const itensAtualizados: ICarrinhoItem[] = [];

            data.itens.forEach((itemData: IReceituarioItem) => {
                const itemToUpdate = openDialogReceita.find(item => item.id === itemData.item_id);
                if (itemToUpdate) {
                    const updatedItem = {
                        ...itemToUpdate,
                        cultura: {
                            id: itemData.cultura_id,
                            nome: itemData.nome_cultura
                        },
                        praga: {
                            id: itemData.praga_id,
                            nome: itemData.nome_cientifico
                        }
                    };

                    itensAtualizados.push(updatedItem);
                }
            });

            if (itensAtualizados.length > 0) {
                editarItem(itensAtualizados[0]);
            }
        }
    };

    const editarItem = (item: ICarrinhoItem, condicaoAtual?: string) => {

        const getKeyId = (i: ICarrinhoItem) => `${String(i.id)}|${String(i.loja.id)}`;
        const getKeyProdutoId = (i: ICarrinhoItem) => `${String(i.produto_id)}|${String(i.loja.id)}`;
        const isSameItem = (itemAtual: ICarrinhoItem, novoItem: ICarrinhoItem) => getKeyProdutoId(itemAtual) === getKeyId(novoItem) || getKeyId(itemAtual) === getKeyId(novoItem);

        const itemExistente = itens.find((carrinhoItem: ICarrinhoItem) => isSameItem(carrinhoItem, item));

        if (item.emite_receita === "S" && (!item.cultura || !item.praga) && condicaoAtual !== "excluir" && (!itemExistente || (itemExistente && (itemExistente.cultura === undefined || itemExistente.praga === undefined)))
        ) {
            setOpenDialogReceita([item]);
            return;
        }

        let novoItens: ICarrinhoItem[] = itens;

        if (itemExistente) {
            switch (condicaoAtual) {
                default: {
                    const quantidadeDesejada = itemExistente.quantidade + item.quantidade;
                    if (quantidadeDesejada > item.loja.estoque) {
                        enqueueSnackbar("Quantidade excedida no estoque!", { variant: "error" });
                        return;
                    }
                    novoItens = novoItens.map((carrinhoItem) =>
                        isSameItem(carrinhoItem, item)
                            ? { ...carrinhoItem, quantidade: quantidadeDesejada }
                            : carrinhoItem
                    );
                    break;
                }
                case "editar": {
                    novoItens = novoItens.map((carrinhoItem) =>
                        isSameItem(carrinhoItem, item)
                            ? {
                                ...carrinhoItem,
                                quantidade: item.quantidade,
                                desconto: item.desconto ?? carrinhoItem.desconto,
                                tipoDesconto: item.tipoDesconto ?? carrinhoItem.tipoDesconto,
                                preco: item.preco ?? carrinhoItem.preco,
                                praga: item.praga ?? carrinhoItem.praga,
                                cultura: item.cultura ?? carrinhoItem.cultura,
                            }
                            : carrinhoItem
                    );
                    break;
                }
                case "excluir": {
                    novoItens = itens.filter((carrinhoItem: ICarrinhoItem) => !isSameItem(carrinhoItem, item));
                    break;
                }
            }
        } else {
            // Item novo: adiciona ao carrinho
            novoItens = [...itens, item];
        }
        // Normalização para o payload do backend (padroniza estrutura)
        const normalizarItemPayload = (i: ICarrinhoItem) => ({
            id: i.id,
            quantidade: i.quantidade,
            preco: i.preco,
            loja_id: i.loja.id,
            desconto: i.desconto ?? 0,
            desconto_tipo: i.tipoDesconto === '%' ? 'Percentual' : 'Valor fixo',
            ...(i.praga ? { praga_id: i.praga.id } : {}),
            ...(i.cultura ? { cultura_id: i.cultura.id } : {}),
            acrescimo: 0,
            frete: 0
        });

        const novoFormData: IEditarPedidoPayload = {
            id: formData.id,
            itens: novoItens.map(normalizarItemPayload),
        };
        editarPedido(novoFormData);
    };


    const { mutate: editarPedido } = useMutation({
        mutationKey: "editar-pedido",
        mutationFn: (data: IEditarPedidoPayload) =>
            axiosClient.put(`/comercial/pedidos/editar-pedido/${data.id}`, data),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Erro ao editar pedido!", { variant: "error" });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(`comercial/detalhar-pedido`);
            setOpenDialogEdit(false)
            enqueueSnackbar("Item editado com sucesso!", { variant: "success" });
        },
    });


    const itensPorLoja = data.itens.reduce<Record<number, IItensPorLojaDetalhes>>((acc, item) => {
        const lojaId = item.loja.id;
        if (!acc[lojaId]) {
            acc[lojaId] = {
                loja: item.loja,
                itens: []
            };
        }
        acc[lojaId].itens.push(item);
        acc[lojaId].itens.sort((a, b) => a.nome.localeCompare(b.nome));
        return acc;
    }, {});

    const itensPerloja = Object.values(itensPorLoja);

    const algumItemPago = useMemo(() => {
        return data.pagamentos.some(
            (item: TPagamentoDetalhes) => item.status === "Pago"
        );
    }, [data.pagamentos]);

    return (
        <PaperBox>
            <Grid sx={{ direction: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" mb={2}>Itens</Typography>

                {
                    (data.situacao === "Aprovação" || (data.situacao === "Pagamento" && !algumItemPago)) && vendedores &&
                    <IconButton size="small"
                        onClick={() => setOpenDialogEdit(true)}
                    >
                        <ShoppingCart />
                    </IconButton>
                }
            </Grid>
            <List>
                {itensPerloja.map((item, index) => (
                    <Fragment key={index}>
                        <Typography
                            mb={1}
                            variant="subtitle2"
                        >
                            <b>{item.loja.id} - {item.loja.nome}</b>
                        </Typography>
                        {
                            item.itens.map((item, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        mb: 2,
                                        p: 2,
                                    }}
                                >

                                    <Box display={'flex'} alignItems={'center'}>
                                        <Box
                                            component="div"
                                            sx={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: 2,
                                                backgroundImage: `url(${item.imagem?.url || "/imgs/imagem-invalida.png"})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                marginRight: 2,
                                            }}
                                        />
                                        <Box>
                                            <Typography sx={{ fontWeight: 'bold' }}>{item.produto_id} - {item.nome}</Typography>
                                            <Typography
                                                variant="caption"
                                                color="text.secondary"
                                            >
                                                {item.quantidade} x ({formatarValorMonetario(item.preco)}
                                                {item.desconto > 0 && ` - ${formatarValorMonetario(item.desconto)}`})
                                                = {formatarValorMonetario((item.quantidade * item.preco) - (item.quantidade * item.desconto))}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box sx={{ ml: 'auto', mr: 4 }}>
                                        <Box border={1} borderRadius={2} borderColor="primary.main" px={1}>
                                            <Typography variant="caption" color="primary">{item.estoque_disponivel} itens disponíveis</Typography>
                                        </Box>
                                    </Box>


                                    {(data.situacao === "Aprovação" || (data.situacao === "Pagamento" && !algumItemPago)) && vendedores && (
                                        <>
                                            <IconButton
                                                color="primary"
                                                onClick={(e) => handleClick(e, String(item.id), item.loja.id)}
                                                size="small"
                                            >
                                                <MoreVertIcon />
                                            </IconButton>

                                            <Menu
                                                anchorEl={menuState.anchorEl}
                                                open={
                                                    Boolean(menuState.anchorEl) &&
                                                    menuState.itemId === String(item.id) &&
                                                    menuState.lojaId === item.loja.id
                                                }
                                                onClose={handleClose}
                                            >
                                                <MenuItem onClick={() => onEditarItem(item)}>
                                                    <EditIcon sx={{ mr: 1 }} fontSize="small" />
                                                    Editar
                                                </MenuItem>
                                                <MenuItem onClick={() => {
                                                    editarItem({
                                                        ...item,
                                                        id: String(item.id),
                                                        produto_id: String(item.produto_id),
                                                        praga: item.praga || undefined,
                                                        cultura: item.cultura || undefined,
                                                        loja: {
                                                            ...item.loja,
                                                            estoque: item.estoque_disponivel
                                                        }
                                                    }, "excluir");
                                                }}
                                                >
                                                    <DeleteIcon sx={{ mr: 1 }} fontSize="small" color="error" />
                                                    Remover
                                                </MenuItem>
                                            </Menu>
                                        </>
                                    )}
                                </Box>
                            ))}
                    </Fragment>
                ))}
            </List>

            {
                openDialogEditItem !== null && (
                    <DialogEditItem
                        open={Boolean(openDialogEditItem)}
                        onClose={() => { setOpenDialogEditItem(null); }}
                        onEditarItem={(novoItem) => {
                            editarItem(novoItem, "editar");
                        }}
                        item={{
                            id: String(openDialogEditItem.id),
                            nome: openDialogEditItem.nome,
                            produto_id: String(openDialogEditItem.produto_id),
                            quantidade: openDialogEditItem.quantidade,
                            desconto: openDialogEditItem.desconto,
                            tipoDesconto: openDialogEditItem.desconto_tipo === "Valor fixo" ? "R$" : "%",
                            imagem: openDialogEditItem.imagem,
                            preco: openDialogEditItem.preco,
                            loja: {
                                id: openDialogEditItem.loja.id,
                                nome: openDialogEditItem.loja.nome,
                                parametros: openDialogEditItem.loja.parametros,
                                estoque: openDialogEditItem.estoque_disponivel,
                            },
                            emite_receita: openDialogEditItem.emite_receita,
                            agrotoxico_id: openDialogEditItem.agrotoxico_id
                        }}
                    />
                )
            }

            {
                openDialogEdit &&
                <Dialog
                    open={openDialogEdit}
                    onClose={() => setOpenDialogEdit(false)}
                    fullWidth
                    maxWidth="lg"
                >
                    <ListaProdutos defaultValueCliente={adaptToIDataPublicos(formData)} onAddItem={editarItem} />
                    <DialogActions
                        sx={{ display: "flex", justifyContent: "flex-end", py: 2, px: 2 }}
                    >
                        <Button variant="outlined" onClick={() => setOpenDialogEdit(false)}>
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            }

            {openDialogReceita && (
                <DialogReceituario
                    open={Boolean(openDialogReceita)}
                    handleClose={() => setOpenDialogReceita(null)}
                    itensComReceita={openDialogReceita}
                    onSave={handleSaveReceituario}
                />
            )}

        </PaperBox>
    )
}

interface PropsCardItens extends CardProps { }

export interface IItensPorLojaDetalhes {
    loja: TLoja;
    itens: TProdutosDetalhes[];
}

export function adaptToIDataPublicos(backendPublico: any): IDataPublicos {
    return {
        ...backendPublico,
        selected_fazenda: backendPublico.selected_fazenda,
    };
}
